"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbolForLocation = exports.currencyForCountry = exports.getCurrencySymbol = exports.Currency = void 0;
var Country_1 = require("./Country");
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["DKK"] = "DKK";
    Currency["NOK"] = "NOK";
    Currency["SEK"] = "SEK";
    Currency["ISK"] = "ISK";
    Currency["GBP"] = "GBP";
})(Currency || (exports.Currency = Currency = {}));
var getCurrencySymbol = function (currency) {
    switch (currency) {
        case Currency.DKK:
        case Currency.ISK:
        case Currency.NOK:
        case Currency.SEK: {
            return "kr";
        }
        case Currency.EUR: {
            return "€";
        }
        case Currency.GBP: {
            return "£";
        }
        case Currency.USD: {
            return "$";
        }
    }
};
exports.getCurrencySymbol = getCurrencySymbol;
var currencyForCountry = function (country) {
    switch (country) {
        case Country_1.Country.dk:
            return Currency.DKK;
        case Country_1.Country.eu:
            return Currency.EUR;
        case Country_1.Country.is:
            return Currency.ISK;
        case Country_1.Country.gb:
            return Currency.GBP;
        case Country_1.Country.us:
            return Currency.USD;
    }
};
exports.currencyForCountry = currencyForCountry;
var symbolForLocation = function (country) {
    switch (country) {
        case Country_1.Country.dk:
            return Currency.DKK;
        case Country_1.Country.eu:
            return "€";
        case Country_1.Country.is:
            return Currency.ISK;
        case Country_1.Country.gb:
            return "£";
        case Country_1.Country.us:
            return "US$";
    }
};
exports.symbolForLocation = symbolForLocation;
//# sourceMappingURL=Currency.js.map